
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/first-order-form",
      function () {
        return require("private-next-pages/first-order-form/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/first-order-form"])
      });
    }
  